
import { Vue, Component, Ref } from 'vue-property-decorator';
import quilleditor from '@/components/richText/quilleditor.vue';
import ip6 from '@/assets/ip6.svg';
import previewModal from '@/components/richText/previewModal.vue';
import { CarFieldFactory } from '@/models/carFieldFactory';
import vehicleList from '../components/vehicleList.vue';
import lazyInject from '@/di';
import VehicleService from '@/services/vehicle.service';
import VehicleModal from '@/components/carModule/VehicleModal.vue';
import { EVehicleOperations } from '@/common/enum/carSpu';

// src/components/richText/previewModal.vue
// src/assets/ip6.svg
@Component({
  components: {
    quilleditor,
    previewModal,
    VehicleModal,
    vehicleList,
  },
})
export default class VehicleOperations extends Vue {
  ip6 = ip6;

  @lazyInject(VehicleService)
  private vehicleService!: VehicleService;

  @Ref('previewModal') previewModal!: previewModal;

  @Ref('vehicleModal')
  vehicleModal!: VehicleModal;

  @Ref('vehicleList') vehicleList!: vehicleList;

  content = '';

  size = 'small';

  shopId = '';

  selectedCategoryId = -1;

  categoryList = [];

  labelType = '';

  showModal() {
    const carFields = CarFieldFactory.init({
      spuType: 'vehicleOperations',
    });
    // console.log(carFields);
    this.vehicleModal.setup(carFields, {});
  }

  handleUpdate(value: any, type: boolean) {
    // this.init();
    /* eslint-disable no-param-reassign */
    if (type) {
      value.tags = [];
    }
    const carFields = CarFieldFactory.init({
      spuType: 'vehicleOperations',
    });
    const isTagsIndex = carFields.findIndex(
      (item) => item.label === EVehicleOperations.TAGS,
    );
    if (value.tagslist && value.tagslist.length > 0) {
      carFields[isTagsIndex].isHidden = false;
    } else {
      carFields[isTagsIndex].isHidden = true;
    }
    this.vehicleModal.setup(carFields, value);
  }

  async init() {
    // const res = await this.vehicleService.getCommodityCategory({
    //   shop_id: this.shopId,
    // });
    // console.log(res);
    // this.categoryList = res;
    this.vehicleList.init();
  }

  upload(val: any) {
    // console.log(val);
    this.content = val;
  }

  async handleSubmit(value: any) {
    const { cid, images, name, market_price, price, tags, description } = value;
    const params = {
      shop_id: this.shopId,
      cid,
      images: images ? images.map((item: any) => item.id) : [],
      name,
      market_price,
      price,
      tags,
      v_rank: 1,
      description,
    };
    // console.log(params);
    const res = await this.vehicleService.addCommodity(params);
    if (res) {
      this.$message.success('新增成功');
      this.vehicleList.init();
      this.vehicleModal.onClose();
    }
  }

  mounted() {
    this.init();
    const { shopId, labelType } = this.$route.params;
    this.shopId = shopId;
    this.labelType = labelType;
  }
}
